/* tslint:disable */
/* eslint-disable */
/**
 * Email API
 * API for managing email templates and sending documents via Brevo
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Commande pour récupérer un aperçu du template Brevo avec les variables résolues
 * @export
 * @interface GetTemplatePreviewCommand
 */
export interface GetTemplatePreviewCommand {
    /**
     * ID du template Brevo
     * @type {number}
     * @memberof GetTemplatePreviewCommand
     */
    templateId: number;
    /**
     * Dictionnaire de paramètres à injecter dans le template
     * @type {{ [key: string]: any; }}
     * @memberof GetTemplatePreviewCommand
     */
    params?: { [key: string]: any; };
}

/**
 * Check if a given object implements the GetTemplatePreviewCommand interface.
 */
export function instanceOfGetTemplatePreviewCommand(value: object): value is GetTemplatePreviewCommand {
    if (!('templateId' in value) || value['templateId'] === undefined) return false;
    return true;
}

export function GetTemplatePreviewCommandFromJSON(json: any): GetTemplatePreviewCommand {
    return GetTemplatePreviewCommandFromJSONTyped(json, false);
}

export function GetTemplatePreviewCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTemplatePreviewCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'templateId': json['templateId'],
        'params': json['params'] == null ? undefined : json['params'],
    };
}

export function GetTemplatePreviewCommandToJSON(json: any): GetTemplatePreviewCommand {
    return GetTemplatePreviewCommandToJSONTyped(json, false);
}

export function GetTemplatePreviewCommandToJSONTyped(value?: GetTemplatePreviewCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'templateId': value['templateId'],
        'params': value['params'],
    };
}

